import { Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { H } from '../Layout';

interface ListViewHeaderTitleProps {
    /** The title text to display in the header */
    headerTitle: string;
    /** The FacetsPanel component to render alongside the title */
    FacetsPanelRenderer: () => ReactNode;
}

export const ListViewHeaderTitle = ({ headerTitle, FacetsPanelRenderer }: ListViewHeaderTitleProps) => {
    return (
        <H
            sx={{
                justifyContent: 'space-between',
                backgroundColor: 'background.paper',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                pl: 2,
                py: 1
            }}
        >
            <Typography variant="h6">{headerTitle}</Typography>
            {/* Currently, only headerTitle should be visible, so FacetsPanelRenderer is commented out */}
            {/* {FacetsPanelRenderer()} */}
        </H>
    );
};
